// #2121-spec-kits
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Button, Input, Spinner } from 'reactstrap';
import { translate } from 'react-translate';
import TableAssets from './TableAssets';
import Paginator from '../Common/Paginator';
import { actionGetAssetsList } from 'store/actions/assetsActions';
import { useHistory } from 'react-router-dom';

const AssetsList = (props) => {
  const { t } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, page, lastPage, limit, total } = useSelector((s) => s.assetsReducer.assets);

  const [_page, setPage]            = useState(0);
  const [_limit]                    = useState(20);
  const [totalPage, setTotalPage]   = useState(0);
  const [filter, setFilter]         = useState(null);
  const [loadingLocal, setLoading]  = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setLoading(true);
    dispatch(actionGetAssetsList(_page, _limit));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      setLoading(false);
      setPage(page);
      setTotalPage(lastPage);
    }
  }, [data, page, lastPage]);

  // Search debounce
  useEffect(() => {
    const t = setTimeout(() => {
      const value = searchTerm && searchTerm.length > 2 ? searchTerm.trim() : null;
      if (value !== filter) {
        setFilter(value);
        setLoading(true);
        dispatch(actionGetAssetsList(0, _limit, value));
        setPage(0);
      }
    }, 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const onPageChange = (page) => {
    setLoading(true);
    dispatch(actionGetAssetsList(page, _limit, filter));
  };

  const createAsset = (e) => {
    e.preventDefault();
    history.push('/admin/assets/form/');
  };

  return (
    <div className="content asset-list-page mt-3">

      {/* Header */}
      <div className="asset-list-header">
        <h2 className="asset-list-page-title">
          {t('list-title') || 'Asset inventory and lifecycle.'}
        </h2>
        <Button color="primary" onClick={createAsset} className="asset-list-add">
          <i className="now-ui-icons ui-1_simple-add" /> {t('add-new-asset') || 'New asset'}
        </Button>
      </div>

      {/* Search prominente */}
      <div className="asset-list-search">
        <i className="now-ui-icons ui-1_zoom-bold asset-list-search-icon" />
        <Input
          type="text"
          value={searchTerm}
          placeholder={t('search-rich-placeholder') || 'Search by brand, model, type or serial...'}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && (
          <button
            type="button"
            className="asset-list-search-clear"
            onClick={() => setSearchTerm('')}
            aria-label="Clear"
          >
            <i className="now-ui-icons ui-1_simple-remove" />
          </button>
        )}
        {searchTerm && searchTerm.length > 0 && searchTerm.length <= 2 && (
          <small className="asset-list-search-hint">{t('search-hint') || 'Type at least 3 characters'}</small>
        )}
      </div>

      {/* Tabla */}
      <Card className="asset-list-card">
        <CardBody className="asset-list-card-body">
          {loadingLocal ? (
            <div className="asset-list-loading">
              <Spinner color="primary" />
            </div>
          ) : !data || data.length === 0 ? (
            <div className="asset-list-empty">
              <i className="now-ui-icons design_bullet-list-67" />
              <h5>{t('empty-title') || 'No assets to show'}</h5>
              <p>{filter ? (t('empty-search') || 'No matches for the current search.')
                         : (t('empty-default') || 'Add a new asset to get started.')}</p>
            </div>
          ) : (
            <TableAssets data={data} loading={false} page={_page} callback={onPageChange} />
          )}

          {data && data.length > 0 && (
            <>
              <div className="asset-list-total">
                {t('showing') || 'Showing'} {data.length}
                {typeof total === 'number' && <> {t('of') || 'of'} {total}</>}
              </div>
              <div className="d-flex justify-content-center align-items-center mt-3">
                <Paginator
                  totalPages={totalPage}
                  currentPage={_page}
                  pageSize={_limit}
                  filter={filter}
                  callback={onPageChange}
                  maxPagesToShow={10}
                />
              </div>
            </>
          )}
        </CardBody>
      </Card>

    </div>
  );
};

export default translate('assets')(AssetsList);
